import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from 'app/shared.service';
import { IContenedorMaritimo } from '../maritimo/maritimo.component';

@Component({
    selector: 'app-contenedor-maritimo',
    templateUrl: './contenedor-maritimo.component.html',
    styleUrls: ['./contenedor-maritimo.component.scss']
})
export class ContenedorMaritimoComponent implements OnInit {
    @Input() contenedor: IContenedorMaritimo;
    @Input() catalogo: any[] = [];

    FormContenedor: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        private sharedService: SharedService
    ) {
        this.FormContenedor = this.formBuilder.group({
            Index: [''],
            Id: [0],
            TipoContenedor: [null, [Validators.required, Validators.min(1)]],
            MatriculaContenedor: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
            NumPrecinto: [null]
        });

    }

    ngOnInit(): void {

        //this.FormContenedor.controls.id.setValue(this.id.id)
        this.FormContenedor.valueChanges.subscribe(changes => {
            if (this.FormContenedor.valid) {
                this.sharedService.setFormMaritimoContenedor(changes);
            }
        });

        //Set form
        this.FormContenedor.setValue({
            Index: this.contenedor?.Index,
            Id: this.contenedor?.Id,
            TipoContenedor: this.contenedor?.TipoContenedor,
            MatriculaContenedor: this.contenedor?.MatriculaContenedor,
            NumPrecinto: this.contenedor?.NumPrecinto
        });

    }


}
